module.exports = __webpack_public_path__ + "img/NO937884672.96fa984b.png";